import { Injectable } from "@angular/core";
import { CanActivate, ActivatedRouteSnapshot, Router, CanActivateChild, RouterStateSnapshot } from "@angular/router";
import { AuthentificationService } from "src/app/services/auth/authentification.service";
import { EncryptionService } from "src/app/services/auth/encryption.service";
import { GlobalUtils } from "src/app/utils/global-utils";
const SESSION_URL_PARAM = 'session';
const MANAGER_URL_PARAM = 'manager';

@Injectable({
    providedIn: 'root'
})
export class SignedInGuard implements CanActivate, CanActivateChild {

    constructor(private router: Router, private authentificationService: AuthentificationService, private encryptionService: EncryptionService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.processActivation(route, state);
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.processActivation(route, state);
    }


    processActivation (route, state): boolean {
        let session = route.queryParams[SESSION_URL_PARAM];
        let manager = route.queryParams[MANAGER_URL_PARAM];
        if (session) {
            const data = this.encryptionService.decryptPassword(decodeURIComponent(session));
            this.authentificationService.overrideAccessStorage(JSON.parse(data));
            window.location.href = ([window.location.href.replace('?'+ SESSION_URL_PARAM + '=' + encodeURIComponent(session), '')]).toString();
        } else if (manager) {
            const data = this.encryptionService.decryptPassword(decodeURIComponent(manager));
            this.authentificationService.overrideAccessStorage(JSON.parse(data));
            this.authentificationService.processSuccessfulAuthentication(data);
        } else if (!this.authentificationService.isSignedIn()) {
            this.authentificationService.clearAccessStorage();
            this.router.navigate(['/auth/login']);
            return false;
        }
        let managedRouter : Array<any> = JSON.parse(GlobalUtils.getStorageItem('router'));
        if (state.url != '/' && state.url != '/accueil' && state.url != '/affichage-cgu' && state.url != '/gestion-filiale' && state.url != '/service' && state.url != '/mon-profil' && (!managedRouter || !managedRouter.some(route => route.url === state.url.replace('/', '')))) {
            return false;
        }
        return true;
    }

}
